<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W7tSZQ/tc-custom/scover.jpg?1685327173880" alt="This image is the cover for the book True Tales of Old-Time Kentucky Politics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">True Tales of Old-Time Kentucky Politics
      </h1>
      <p class="bookDescription body article font2">
        <p>Did you know that William Goebel of Kentucky remains the only state governor to be assassinated while in office? Or that Abraham Lincoln, now a favorite son of the Bluegrass State, garnered less than 1 percent of the state's vote in 1860? How about Matthew Lyon, the congressman who won reelection from a jail cell and once bit off the thumb of a voter during a brawl on the House floor? These are but three of the fascinating and little-known stories from Kentucky's political past found in True Tales of Old-Time Kentucky Politics. Join longtime columnist Berry Craig as he shares tales of a time when votes could be bought with a drink and political differences were resolved with ten paces and a pistol.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Berry Craig
      </h2>
      
      <p class="authorDescription body article">Berry Craig serves as professor of history at West Kentucky Community and Technical College in Paducah, where has been on the faculty since 1989. He was a feature writer and columnist for the Paducah Sun-Democrat and Paducah Sun from 1976 to 1989, and also wrote "Kentucky Backroads, "? a freelance Associated Press feature column. He has written articles for the Register of the Kentucky Historical Society, Filson Club History Quarterly and Kentucky Humanities. He received the Kentucky Historical Society's 2001 Richard H. Collins Award for the best article published in the Register that year. In addition to his writing, he is an active speaker on the Kentucky historical circuit, generating a following with his oral overview of the Bombast, Bourbon and Burgoo writings.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d90ce980